import { useStaticQuery, graphql } from "gatsby";

const resourcesQuery = graphql`
  query {
    allContentfulResourceSet {
      edges {
        node {
          title
          locale {
            slug
          }
          resources {
            key
            value {
              value
            }
          }
        }
      }
    }
  }
`;

function useTranslations(country: string, keys: string[]) {
  const {
    allContentfulResourceSet: { edges: resourceSet },
  } = useStaticQuery(resourcesQuery);

  const resources  = resourceSet.filter(resource =>
    resource.node.locale.some(locale => locale.slug == country)
  )[0].node.resources;

  const resourcesMap = resources.reduce((acc, { key, value }) => {
    acc[key] = value.value;
    return acc;
  }, {});

  return keys.map(k => resourcesMap[k]);
}

export default useTranslations;
